// Tooltip padrão do Chart.js é desenhado dentro do próprio canvas — em canvases
// pequenos (76px) o texto do tooltip é cortado quando não cabe nesse espaço.
// Esse handler substitui pelo recipe oficial de "external tooltip": um <div>
// HTML normal, fora do canvas, que pode ocupar o espaço que precisar.
export function externalTooltipHandler(context) {
    const { chart, tooltip } = context;
    const { canvas } = chart;

    let tooltipEl = canvas.parentNode.querySelector('div.chartjs-external-tooltip');

    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.className = 'chartjs-external-tooltip';
        tooltipEl.style.background = '#21262F';
        tooltipEl.style.borderRadius = '6px';
        tooltipEl.style.color = '#fff';
        tooltipEl.style.opacity = 0;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(-50%, -110%)';
        tooltipEl.style.transition = 'opacity .1s ease';
        tooltipEl.style.padding = '6px 10px';
        tooltipEl.style.fontSize = '11px';
        tooltipEl.style.fontFamily = 'Lato';
        tooltipEl.style.fontWeight = '700';
        tooltipEl.style.whiteSpace = 'nowrap';
        tooltipEl.style.zIndex = 10;

        canvas.parentNode.style.position = 'relative';
        canvas.parentNode.appendChild(tooltipEl);
    }

    if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
    }

    if (tooltip.body) {
        const titleLines = tooltip.title || [];
        const bodyLines = tooltip.body.map((b) => b.lines);

        let innerHtml = '';
        titleLines.forEach((title) => { innerHtml += `<div>${title}</div>`; });
        bodyLines.forEach((body) => { innerHtml += `<div>${body}</div>`; });
        tooltipEl.innerHTML = innerHtml;
    }

    const { offsetLeft: positionX, offsetTop: positionY } = canvas;

    tooltipEl.style.opacity = 1;
    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
}
